// import React from "react";
import { Col, Row } from "react-bootstrap";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { RiScales2Fill } from "react-icons/ri";
import style from "./Size.module.scss";
import { SiOxygen } from "react-icons/si";
import swal from "sweetalert";

const ExtraCylinder = () => {
  const navigate = useNavigate();
  const { orderType } = useSelector((state) => state.newOrderReducer);

  let userDetails;
  if (localStorage.getItem("userToken")) {
    userDetails = JSON.parse(localStorage.getItem("userToken"));
  }

  if (!userDetails) {
    navigate("/");
  }

  const colors = () => {
    if (orderType?.cardText === "BLOOD") return "#B70303";
    if (orderType?.cardText === "OXYGEN") return "#0779F7";
    if (orderType?.cardText === "STOCKBANK") return "#066304";
    return "#DA621B";
  };

  const handleNo = async () => {
    const result = await swal({
      // title: "Emergency Order",
      content: {
        element: "div",
        attributes: {
          innerHTML: `
          <p style="font-size:18px; margin-top:8px;">
            I understand, Ma/Sir. we will deliver just a unit to you to serve you for your urgent needs.
            <br>
            <br>
            Would you like me to arrange this emergency delivery for you? While we also pick up your empty cylinders for the scheduled delivery.

          </p>
        `,
        },
      },
      // icon: "warning",
      buttons: {
        confirm: {
          text: "Yes",
          value: "yes",
          visible: true,
          className: "btn btn-success",
          closeModal: true,
        },
        cancel: {
          text: "No",
          value: "no",
          visible: true,
          className: "btn btn-primary",
          closeModal: true,
        },
      },
      closeOnClickOutside: false,
      closeOnEsc: false,
    });

    // Save user selection to localStorage
    localStorage.setItem("extraCylinderOption", JSON.stringify(result));
    // Navigate after storing result
    navigate("/place-order/size");
  };

  const handleYes = () => {
    localStorage.setItem("extraCylinderOption", JSON.stringify("no"));
    navigate("/place-order/size");
  };

  return (
    <div style={{ width: "97%" }}>
      <Row>
        <Col md={1}>
          <IoIosArrowDropleftCircle
            size={50}
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
            color={colors()}
          />
        </Col>
        <Col md={10}>
          <div className={style.form}>
            <div className={style.outerContainer}>
              <div className={style.iconContainer}>
                <SiOxygen color="#0779F7" size={50} />
              </div>
              <div className={style.container}>
                <p className={style.size}>Emergency Cylinder</p>
              </div>
              <div className={style.greeting}>
                <p>
                  <span style={{ color: "#b70303", fontWeight: "bold" }}>
                    LifeBank CSA Script |{" "}
                  </span>
                  Please note that we have implemented a scheduled model for
                  cylinder pickups and deliveries to better serve you. We will
                  pick up cylinders on Thursdays and Fridays and deliver them on
                  Mondays and Tuesdays. Please confirm if the cylinders will be
                  available for pickup on those days.
                </p>
              </div>
              <div className={style.button} onClick={handleNo}>
                yes
              </div>
              <div className={style.button} onClick={handleYes}>
                no
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ExtraCylinder;
